import React, { useState } from 'react'
import MoveflexClubIcon from './../../../components/custom-icons/moveflex-club-icon.component'
import ModalConfirmation from './../../../components/modal/modal-confirmation.component'
import PaymentConditions from './payment-conditions.component'
import { routes } from '../../../constants/routes.constants'
import { history } from '../../../helpers'
import {
	StyledStartingAt,
	StyledConditionsContainer,
	StyledPaymentCondition,
	StyledIconContainer,
} from './styled-components'

import PixLogo from '../../../../../client/assets/images/pix-cartao.png'

function PaymentInfoContent({
	user,
	productId,
	onPaymentSelected,
	paymentConditions,
	selectedCondition,
}) {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const points = Math.min.apply(
		null,
		paymentConditions
			.filter(({ price, forSubscribers }) => !price && !forSubscribers)
			.map(({ points }) => points)
	)

	const price = Math.min.apply(
		null,
		paymentConditions
			.filter(({ price, forSubscribers }) => price && !forSubscribers)
			.map(({ price }) => price)
	)

	const sliceIndex = -Math.max(Math.log10(productId), 4)
	const productCode = ('000' + productId).slice(sliceIndex)

	const onResult = (confirmed) => {
		setIsModalOpen(false)
		if (confirmed) {
			history.push(`${routes.CLIENTE}/planos`)
		}
	}

	return (
		<div>
			<p>
				<span>Código do produto: {productCode}</span>
			</p>
			{/* {points  === 0 ? (
				<StyledStartingAt className={'bold'}>
					A partir de{' '}
					<span className={'blue'}>reais</span>{' '}
				</StyledStartingAt>
			) : (
				<StyledStartingAt className={'bold'}>
					A partir de{' '}
					<span className={'blue'}>{points.toLocaleString('pt-BR')}</span>{' '}
				</StyledStartingAt>
			)} */}

			<StyledStartingAt className={'bold'}>
				A partir de <span className={'blue'}>{price.$toReais()}</span>{' '}
			</StyledStartingAt>
			<p>
				<span>Selecione a opção de pagamento:</span>
			</p>
			<StyledConditionsContainer>
				<StyledPaymentCondition>
					<img
						src={PixLogo}
						width={139}
						height={44}
						style={{paddingRight:'10px'}}
						alt="Forma Pagamento"
					/>
					{/* <StyledIconContainer></StyledIconContainer> */}
					<PaymentConditions
						user={user}
						isForSubscribers={false}
						onSelect={onPaymentSelected}
						selectedCondition={selectedCondition}
						paymentConditions={paymentConditions}
					/>
				</StyledPaymentCondition>
				{/* <StyledPaymentCondition>
					<StyledIconContainer>
						<MoveflexClubIcon />
					</StyledIconContainer>
					<PaymentConditions
						user={user}
						isForSubscribers={true}
						onSelect={onPaymentSelected}
						setIsModalOpen={setIsModalOpen}
						paymentConditions={paymentConditions}
						selectedCondition={selectedCondition}
					/>
				</StyledPaymentCondition> */}
			</StyledConditionsContainer>

			{/* <ModalConfirmation
				onResult={onResult}
				isOpen={isModalOpen}
				title="Clube Muviflex">
				Esta opção de pagamento é exclusiva para membros do Clube Muviflex.
				Deseja conhecer as vantagens do Clube Muviflex?
			</ModalConfirmation> */}
		</div>
	)
}

export default PaymentInfoContent
